import React from "react";

import { Line } from "react-chartjs-2";
import { Chart, registerables } from 'chart.js';
import moment from 'moment'
import {numberWithCommas, roundDecimals, numberToAmericanFormat} from './functions';
Chart.register(...registerables);



export default function LowHighChart(props) {

    const data = {
        labels: [props._values[3] != undefined ? '3 Days Ago' : '-', props._values[2] != undefined ? '2 Days Ago' : '-', props._values[1] != undefined ? 'Yesterday' : '-', 'Today'],
        datasets: [
          {
            label: "High",
            data: [props._values[3] != undefined ? props._values[3].high_average : 0, props._values[2] != undefined ? props._values[2].high_average : 0, props._values[1] != undefined ? props._values[1].high_average : 0, props._values[0] != undefined ? props._values[0].high_average : 0],
            fill: true,
            borderColor: "rgba(75,192,192,1)"
          },
          {
            label: "Low",
            data: [props._values[3] != undefined ? props._values[3].low_average : 0, props._values[2] != undefined ? props._values[2].low_average : 0, props._values[1] != undefined ? props._values[1].low_average : 0, props._values[0] != undefined ? props._values[0].low_average : 0],
            fill: false,
            borderColor: "#742774"
          }
        ]
      };

  return (
    <div style={{width:250, height:150}}>
      <Line data={data} />
    </div>
  );
}
